<template>

    <b-row class="mb-2" v-if="containerList.length > 0">
        <b-col cols="12">
            <table id="ffContainer" class="table table-bordered" v-if="containerList.length > 0">
                <thead>
                    <tr>
                        <th>SN.</th>
                        <th>Container Type</th>
                        <th>Container No.</th>
                        <th>SOB Date</th>
                        <th>SOB Status</th>
                        <th>Remarks</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in containerList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td v-if="editIndex === index">
                            <input :disabled="true" v-model="editableRow.containerType" class="form-control" />
                        </td>
                        <td v-else>{{ item.containerType }}</td>
                        <td v-if="editIndex === index">
                            <input  :disabled="true" v-model="editableRow.containerNo" class="form-control" />
                        </td>
                        <td v-else>{{ item.containerNo }}</td>
                        <td v-if="editIndex === index">
                            <input type="date" v-model="editableRow.cont_sob" class="form-control" />
                        </td>
                        <td v-else>{{ item.cont_sob }}</td>

                        <td>{{ item.cont_sob_status ? 'Done' : 'Pending' }}</td>
                        <td>{{ item.remarks }}</td>
                        <td v-if="item.uniqueContainerId && item.allModuleId">
                             <!-- && !item.cont_sob_status -->
                            <button v-if="editIndex === index" @click="saveContainer(index)"
                                class="btn btn-success btn-sm">
                                Save
                            </button>
                            <button v-if="editIndex === index" @click="cancelEdit()" class="btn btn-secondary btn-sm">
                                Cancel
                            </button>
                            <button v-else @click="editContainer(item, index)" class="btn btn-primary btn-sm">
                                Edit
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-col>
        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    </b-row>

</template>

<script>
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import NodeLockPannelService from "../../services/NodeLockPannelService";
export default {
    props: {
        allModuleId: { type: Number, default: null },
        JobNo: { type: String, default: null },
    },
    beforeMount() {
        if (this.allModuleId) {
            this.getContainerList();
        }
    },
    data() {
        return {
            JobAssNo: this.JobNo,
            JobId: this.allModuleId,
            containerList: [],
            editIndex: null, // Tracks which row is being edited
            editableRow: {}, // Holds the row data being edited
            alert: {
                content: "Added Succesfully",
                ok: "ok",
            },
        };
    },
    components: {
        ModelListSelect,
        MultiSelect,
        Multiselect,
    },
    computed: {

    },
    created() {

    },
    methods: {
        editContainer(item, index) {
            // Set the editable row and index
            this.editIndex = index;
            this.editableRow = item; // Create a copy to avoid direct mutation
        },
        cancelEdit() {
            // Reset edit state without saving changes
            this.editIndex = null;
            this.editableRow = {};
        },
        saveContainer(index) {
            // Validate and save the updated data
            if (this.editableRow.containerNo && this.editableRow.containerType) {

                console.log("Updated Row Data:", this.editableRow);

                // Optional: Call an API to save the changes to the backend
                NodeLockPannelService.updateJobContainer(this.editableRow)
                    .then(response => {
                        const { data, status, statusText } = response;
                        this.editIndex = null; // Reset edit state
                        this.editableRow = {};
                        console.log("Update successful:", response.data);
                        this.alert.content = data.message;
                        this.$refs["addPop"].open();
                        this.getContainerList();
                        this.$emit('update', this.localData);
                    })
                    .catch(error => {
                        console.error("Update failed:", error);
                    });
            } else {
                console.error("Please fill out all required fields.");
            }
        },
        verifyJoBWiseContainer() {
            return new Promise((resolve) => {
                let payLoad = {
                    module_type: "FF Export",
                    allModuleId: this.allModuleId,
                };
                // console.log("MypayLoad=>",payLoad.length);return false;
                NodeLockPannelService.verifyContainer(payLoad)
                    .then((response) => {
                        const { data, status, statusText } = response;
                        console.log("data PS=>", data);

                        return resolve(data);
                    })
                    .catch((error) => {
                        console.log("Catch on verifyJoBWiseContainer Error: ", error);
                    });
            });
        },
        async getContainerList() {
            // let checkContValueExit = await this.verifyJoBWiseContainer();
            // if (!checkContValueExit.data && !checkContValueExit.data[0].subsFailedStatus) {
            // if (
            // checkContValueExit &&
            // checkContValueExit.data &&
            // !checkContValueExit.data[0].subsFailedStatus
            // ) {
                let payLoad = {
                    allModuleId: this.JobId,
                };
                NodeLockPannelService.getJobContainerList(payLoad)
                    .then((response) => {
                        const { data, status, statusText } = response;
                        if (status == 200 && data) {
                            this.containerList = data.data;
                            console.log("data PS=>", data);
                        }
                    })
                    .catch((error) => {
                        console.log("Catch on getContainerList Error: ", error);
                    });
            // }
        },

    }
};
</script>


// WEBPACK FOOTER //
// UpdateContainerWithSOB.vue?233b3fc5